/* unplugin-vue-components disabled */import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/logo-small.png';
import _imports_1 from '@/assets/images/logo1.png';
var _hoisted_1 = {
  key: 0,
  src: _imports_0
};
var _hoisted_2 = {
  key: 1,
  src: _imports_1
};
var _hoisted_3 = {
  key: 2,
  src: _imports_1
};
var _hoisted_4 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_i_link = _resolveComponent("i-link");
  var _directive_color = _resolveDirective("color");
  var _directive_bold = _resolveDirective("bold");
  var _directive_font = _resolveDirective("font");
  return _openBlock(), _createBlock(_component_i_link, {
    class: _normalizeClass(["i-layout-header-logo", {
      'i-layout-header-logo-stick': !_ctx.isMobile
    }]),
    style: _normalizeStyle($options.style),
    to: "/"
  }, {
    default: _withCtx(function () {
      return [$options.layout.showLogo ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_ctx.isMobile ? (_openBlock(), _createElementBlock("img", _hoisted_1)) : _ctx.headerTheme === 'light' ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : (_openBlock(), _createElementBlock("img", _hoisted_3))], 64 /* STABLE_FRAGMENT */)) : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [_createTextVNode(_toDisplayString($options.layout.title), 1 /* TEXT */)])), [[_directive_color, $options.layout.headerTheme === 'dark' ? '#fefefe' : '#515a6e'], [_directive_bold], [_directive_font, 18]])];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["style", "class"]);
}